import '../styles/index.css';

import $ from 'jquery';

import 'ammap3/ammap/ammap';
import 'ammap3/ammap/ammap.css';
import 'ammap3/ammap/maps/js/worldHigh.js';

((
    ($) => {

        if (typeof _map === 'undefined') {
            return false;
        }
        if (typeof _map.countries === 'undefined' || _map.countries.length === 0) {
            return false;
        }

        let _sending = false;
        let _form = $('.js-filter-form');
        let _contentHolder = $('.js-projects-holder');
        let _title = application.translations.all_projects;

        let _chainSelect = $('.js-country-chain');
        let _chainSelectTarget = $('.js-country-chain-target');

        const get = (_key, _default = null) => {
            if (_map[_key] === undefined || _map[_key].length === 0) {
                return _default;
            }
            return _map[_key];
        };

        // require.context('./maps', true, /\.js$/);
        $.each(_map.countries, (id, country) => {
            if (typeof country.map !== "undefined") {
                require('./maps/' + country.map + '.js');
                // require('ammap3/ammap/maps/js/' + country.map + '.js');
            }
        });

        let _mapObject = AmCharts.makeChart("js-project-map", {
            "type": "map",
            "mouseWheelZoomEnabled": true,
            "preventDragOut": true,
            "allowClickOnSelectedObject": false,
            "tapToActivate": false,
            "zoomOnDoubleClick": false,
            "areasSettings": {
                "autoZoom": true,
                "selectedColor": "#0068a7",
                rollOverOutlineColor: "#0068a7",
                rollOverColor: "#0068a7",
                "color": "#003348",
                "unlistedAreasColor": "#eeeeee",
                "outlineColor": '#ffffff91',
                "outlineThickness": '0.5',
            },
        });

        let _areas = [];
        $.each(_map.countries, (i, c) => {
            let _c = {...c};
            _c.id = _c.code;
            _areas.push(_c);
        });
        let _worldDataProvider = {
            "map": "worldHigh",
            "areas": _areas,
            'zoomLevel': get('zoomLevel', 28),
            'zoomLatitude': get('zoomLatitude', 32),
            'zoomLongitude': get('zoomLongitude', 36),
        };
        _mapObject.dataProvider = _worldDataProvider;

        _mapObject.addListener("init", function (event) {
            _toggleLoader('hide');
        });

        // _mapObject.addTitle(application.translations.all_projects, 22, '#0068a7');
        _mapObject.addLabel(50, 10, application.translations.all_projects, 'left', 22, '#0068a7');

        _mapObject.addListener("clickMapObject", function (event) {
            let _id = event.mapObject.id;
            event.mapObject.chart.titles = [];
            _title = application.translations.place_projects + ' ' + event.mapObject.title;
            // _mapObject.addTitle(_title, 22, '#0068a7');
            // event.mapObject.chart.validateNow();
            _mapObject.clearLabels();
            _mapObject.addLabel(50, 10, _title, 'left', 22, '#0068a7');
            if (typeof event.mapObject.parentObject === 'undefined' || typeof event.mapObject.parentObject.map === 'undefined' || event.mapObject.parentObject.map !== 'worldHigh') {
                _chainSelectTarget.val(_id);
                _fetchProjects();
                return;
            }
            if (_chainSelect.length) {
                _chainSelect.val(_id);
                if ("createEvent" in document) {
                    var evt = document.createEvent("HTMLEvents");
                    evt.initEvent("change", false, true);
                    _chainSelect[0].dispatchEvent(evt);
                } else {
                    _chainSelect[0].fireEvent("onchange");
                }
            }
            _fetchProjects();
            let _m = null;
            if (typeof event.mapObject.map !== 'undefined') {
                _m = event.mapObject.map;
            }
            if (!_m) {
                return;
            }
            setTimeout(function () {
                loadNewMap(_m);
            }, 750);
        });

        function loadNewMap(mapName) {
            _mapObject.dataProvider = {
                mapVar: AmCharts.maps[mapName],
                getAreasFromMap: true,
            };
            _mapObject.validateData();
        }

        const _resetMap = () => {
            _mapObject.dataProvider = _worldDataProvider;
            _mapObject.mouseWheelZoomEnabled = true;
            _mapObject.titles = [];
            _title = application.translations.all_projects;
            // _mapObject.addTitle(application.translations.all_projects, 22, '#0068a7');
            // _mapObject.validateNow();
            _mapObject.clearLabels();
            _mapObject.addLabel(50, 10, application.translations.all_projects, 'left', 22, '#0068a7');
            _mapObject.validateData();

            if (_chainSelect.length) {
                _chainSelect.val('');
                _chainSelectTarget.find('option').each(function () {
                    if ($(this).attr('value').length) {
                        $(this).remove();
                    }
                });
            }
        };

        const _toggleLoader = (action = 'show') => {
            if (action === 'hide') {
                $('.map-wrapper').find('.map-loader').fadeOut();
                _form.find('.projects-filters-btn').removeClass('loading');
            } else if (action === 'show') {
                $('.map-wrapper').find('.map-loader').fadeIn();
                _form.find('.projects-filters-btn').addClass('loading');
            }
        };

        _mapObject.addListener("homeButtonClicked", function (event) {
            _resetMap();
        });

        const _fetchProjects = (_page = 1) => {
            if (_sending) {
                return false;
            }

            let _formData = _form.serializeArray();
            _formData.push({name: 'page', value: _page});
            _formData.push({name: 'json', value: 1});
            _formData.push({name: 'filters', value: 1});

            $.ajax({
                url: _form.attr('data-action'),
                method: 'get',
                dataType: 'json',
                data: _formData,
                contentType: 'application/json',
                beforeSend: function () {
                    _sending = true;
                    _toggleLoader('show');
                    _contentHolder.empty();
                },
                success: function (response) {
                    if (response.status) {
                        if (typeof response.html !== 'undefined' && response.html) {
                            _contentHolder.html(response.html);
                        } else {
                            _contentHolder.html(`<div class="alert alert-less-padding alert-warning">${application.translations.no_projects}</div>`);
                        }
                        _contentHolder.prepend(`<div class="js-projects-holder-title">${_title}</div>`);
                        _mapObject.mouseWheelZoomEnabled = false;
                        $('html, body').animate({scrollTop: _contentHolder.offset().top}, 750, function () {
                            // $('html, body').animate({scrollTop: window.scrollY - 100}, 100);
                        });
                    }
                },
                error: function () {
                },
                complete: function () {
                    _sending = false;
                    _toggleLoader('hide');
                },
            });
            return false;
        };

        if (_form.length) {
            _form.submit(function (e) {
                e.preventDefault();
                _fetchProjects();
            });
        }

        $('body').on('click', '.js-project-paging', function (e) {
            e.preventDefault();
            let _clicked = $(this);
            let _page = 1;
            if (typeof _clicked.attr('data-page') !== 'undefined') {
                _page = _clicked.attr('data-page');
            }
            _fetchProjects(_page);
        });

        if (_chainSelect.length) {
            _chainSelect.change(function (e) {
                let _countryCode = $(this).val();
                if (!_countryCode.length) {
                    _resetMap();
                    return;
                }
                let _countries = get('countries');
                $.each(_countries, (_id, _country) => {
                    if (_countryCode === _id && typeof _country.map !== 'undefined') {
                        loadNewMap(_country.map);
                    }
                });
            });
        }

        if (_chainSelectTarget.length) {
            _chainSelectTarget.change(function (e) {
                let _areaCode = $(this).val();
                let _countryCode = _chainSelect.val();
                if (!_areaCode.length) {
                    let _countries = get('countries');
                    $.each(_countries, (_id, _country) => {
                        if (_countryCode === _id && typeof _country.map !== 'undefined') {
                            loadNewMap(_country.map);
                        }
                    });
                    return;
                }
                let _areaObject = _mapObject.getObjectById(_areaCode);
                _mapObject.clickMapObject(_areaObject);
            });
        }

    }
)(jQuery));